import { ProgramInfiniteSessionTypeOf, ProgramOnOffSessionTypeOf } from "@/modules/sessions/programSessionTypes"
import {
  getSessionBlockValidationSchema,
  type SessionBlockFormikType,
} from "@/modules/sessions/sessionForm/sessionBlockFormikTypes"
import { word } from "@modules/core/utils/i18n"
import { requiredInput } from "@modules/form/formUtils"
import * as Yup from "yup"

export type ProgramSessionInputKey =
  | "name"
  | "date"
  | "programId"
  | "description"
  | "blocks"
  | "startDateTime"
  | "endDateTime"
  | "cardioTag"
  | "weightliftingTag"
  | "gymnasticTag"
  | "dayIndex"
  | "restDay"
  | "hideSessionContent"
  | `${string}.category`
  | `${string}.otherCategory`
  | `${string}.description`
  | `${string}.durationInMin`
  | `${string}.trainingTime[${number}]`
  | `${string}.restTime[${number}]`
  | `${string}.numberOfSets`
  | `${string}.numberOfRounds`
  | `${string}.restBetweenSetsTime`
  | `${string}.trainingTime`
  | `${string}.restTime`
  | `${string}.noLimit`
  | `${string}.scoreSetConfigurations`
  | `${string}.scoringOption`
  | `${string}.rpe`
  | `${string}.note`
  | `${string}.noteType`
  | `${string}.url`
  | `${string}.medias`

export function getTemplateSessionValidationSchema() {
  return Yup.object({
    name: requiredInput(Yup.string().max(64, word("form.maximum.characters", { count: 64 }))),
    description: Yup.string().nullable(),
    blocks: Yup.array().of(getSessionBlockValidationSchema()),
    hideSessionContent: Yup.boolean().required(),
  })
}

export function getProgramInfiniteSessionValidationSchema() {
  return Yup.object({
    name: requiredInput(Yup.string().max(64, word("form.maximum.characters", { count: 64 }))),
    date: Yup.date().required(),
    description: Yup.string().nullable(),
    blocks: Yup.array().of(getSessionBlockValidationSchema()),
    hideSessionContent: Yup.boolean().required(),
    isTemplateSaved: Yup.boolean().required(word("global.form.required")),
  })
}

export function getProgramOnOffSessionValidationSchema() {
  return Yup.object({
    name: requiredInput(Yup.string().max(64, word("form.maximum.characters", { count: 64 }))),
    description: Yup.string().nullable(),
    blocks: Yup.array().of(getSessionBlockValidationSchema()),
    programId: Yup.string().required(word("program.planning.errorMessage.SelectProgram")),
    dayIndex: Yup.number().required(word("global.form.required")).positive(word("global.form.positive")),
    restDay: Yup.boolean(),
    isTemplateSaved: Yup.boolean().required(word("global.form.required")),
  })
}

export type ProgramInfiniteSessionFormikType = {
  isTemplateSaved: boolean
  _type: typeof ProgramInfiniteSessionTypeOf
  name: string
  programId: string
  date: Date | null
  description: string | null
  blocks: SessionBlockFormikType[]
  hideSessionContent: boolean
  cardioTag: boolean
  weightliftingTag: boolean
  gymnasticTag: boolean
}

export type ProgramOnOffSessionFormikType = {
  isTemplateSaved: boolean
  _type: typeof ProgramOnOffSessionTypeOf
  name: string
  programId: string
  dayIndex: number | null
  restDay: boolean
  description: string | null
  blocks: SessionBlockFormikType[]
  hideSessionContent: boolean
  cardioTag: boolean
  weightliftingTag: boolean
  gymnasticTag: boolean
}
